import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileDown, CalendarCheck, Trophy } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { getAdminHeaders } from '../lib/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const todayBR = () => {
  const n = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`;
};

const RelatorioEncerramento = () => {
  const [endDate, setEndDate] = useState(todayBR());
  const [loading, setLoading] = useState(false);

  const gerar = async () => {
    if (!endDate) {
      toast.error('Escolha a data de encerramento');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(
        `${API}/reports/ranking-encerramento-pdf?end_date=${endDate}`,
        { headers: getAdminHeaders(), responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `encerramento_projeto_sementes_${endDate}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('PDF baixado');
    } catch (e) {
      // Blob error: parse it
      let msg = 'Erro ao gerar PDF';
      if (e?.response?.data) {
        try {
          const text = await (e.response.data.text ? e.response.data.text() : Promise.resolve(''));
          if (text) {
            try { msg = JSON.parse(text).detail || msg; } catch { msg = text; }
          }
        } catch { /* keep default */ }
      }
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card data-testid="relatorio-encerramento-card" className="bg-gradient-to-br from-[#F2F7F4] to-[#FEFAE6] rounded-2xl p-5 border border-[#1A4D2E]/20">
      <div className="flex items-start gap-3 mb-3">
        <div className="bg-[#1A4D2E] rounded-full p-2 flex-shrink-0">
          <Trophy className="w-5 h-5 text-[#F4D35E]" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-nunito font-bold text-lg text-[#1A4D2E]">Relatorio de Encerramento</h3>
          <p className="font-inter text-sm text-gray-600 mt-1">
            Gera PDF com <strong>ranking geral, masculino e feminino</strong> ate a data escolhida.
            Ideal para cerimonia de encerramento do ciclo.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-[1fr_auto] gap-3 items-end mt-4">
        <div>
          <Label htmlFor="enc-end-date" className="font-inter font-semibold text-[#1A4D2E] mb-1 block flex items-center gap-1">
            <CalendarCheck className="w-4 h-4" /> Data de encerramento
          </Label>
          <Input
            id="enc-end-date"
            type="date"
            data-testid="input-encerramento-date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            max={todayBR()}
            className="rounded-xl bg-white"
          />
        </div>
        <Button
          type="button"
          onClick={gerar}
          disabled={loading}
          data-testid="btn-gerar-encerramento"
          className="bg-[#1A4D2E] hover:bg-[#145A32] text-white rounded-full px-6 py-6 shadow-md"
        >
          <FileDown className="w-4 h-4 mr-2" />
          {loading ? 'Gerando...' : 'Gerar PDF'}
        </Button>
      </div>
    </Card>
  );
};

export default RelatorioEncerramento;
